module.exports = __webpack_public_path__ + "static/media/disciplinary-response.f146d1ce.svg";